import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { InstitutionFormLoaderEffects } from './+state/institution-form-loader-eager.effects';

// @dynamic
@NgModule({
  imports: [EffectsModule.forFeature([InstitutionFormLoaderEffects])]
})
export class InstitutionFormLoaderModule {}
